var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVideoOff = function SvgVideoOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m23.702 17.006-4.171-4.171v2.247l-1.778-1.777V4.767a.36.36 0 0 0-.102-.262.36.36 0 0 0-.263-.103H8.851L7.073 2.624h10.315q.9 0 1.52.622.624.623.623 1.52v5.425l4.17-4.17zm-1.56 6.546L.29 1.699 1.539.45l21.853 21.853zM3.737 2.647 5.49 4.402H3.896a.36.36 0 0 0-.263.103.36.36 0 0 0-.102.262V18.26q0 .159.102.262a.36.36 0 0 0 .263.102h13.492a.36.36 0 0 0 .263-.102.36.36 0 0 0 .102-.262v-1.596l1.755 1.755a2.08 2.08 0 0 1-.662 1.406q-.605.577-1.458.577H3.896a2.07 2.07 0 0 1-1.52-.622 2.07 2.07 0 0 1-.623-1.52V4.767q0-.853.577-1.458a2.08 2.08 0 0 1 1.406-.662"
  })));
};
export default SvgVideoOff;